import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {FormControl, Checkbox, Select} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { sortByName } from '../../../api/helpers';

//import GroupIcon from '@material-ui/icons/Group';

class ScanListEditor_ extends React.Component{

    constructor(props){
        super(props);
        this.state = {menuAnchor: null}
    }

    handleItemSelect(itemID){
        this.props.onItemSelect(itemID)
    }

    isSelected(itemID){
        let selected = itemID === this.props.selectedItemID
        return selected
    }

    getRowStyle(itemID){
        let style = {
            background: this.isSelected(itemID) ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action, itemID){
        itemID = itemID ? itemID : this.state.menuItemID
        this.handleMenuClose();
        this.props.onAction({type: action, itemID: itemID})
    }

    render(){
        const {t} = this.props 
        this.props.scanlists.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        /*
        let filter = this.props.filter.toLowerCase()
        let groups = this.props.filter ? this.props.groups.filter(
            item => item.Name.toLowerCase().indexOf(filter)>=0
        ) : this.props.groups
        */
       let scanlists = this.props.scanlists

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{...styles.head, ...styles.icon}}></TableCell>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                                
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="add scanlist" component="span"
                                        style={styles.addIcon}
                                        onClick={()=>{this.handleMenuItemClick('SCANLIST_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {scanlists.map((scanlist) => 
                            <TableRow key={scanlist.ID} 
                                    onClick={()=>{this.handleItemSelect(scanlist.ID)}}
                                    onDoubleClick={()=>{this.handleMenuItemClick('SCANLIST_EDITOR_OPEN_EDIT', scanlist.ID)}}
                                    style={this.getRowStyle(scanlist.ID)}>

                                <TableCell component="th" scope="row"></TableCell>

                                <TableCell component="th" scope="row">
                                  {scanlist.Name}
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                                        onClick={event=>this.handleMenuClick(event, scanlist.ID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                        <Menu anchorEl={this.state.menuAnchor} keepMounted
                            open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('SCANLIST_EDITOR_OPEN_EDIT')}}>
                                <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                                <ListItemText primary={t('EditScanList')+'...'} />
                            </MenuItem>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('SCANLIST_EDITOR_DELETE')}}>
                                <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                                <ListItemText primary={t('DeleteScanList')} />
                            </MenuItem>
                        </Menu>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const ScanListEditor = withTranslation()(ScanListEditor_);